export class BaseUrlService {
  private _apiLocation: string = '';
  private _websiteLocation: string = '';

  constructor(baseRestUrl?: string, baseWebsiteUrl?: string) {
    this.init(baseRestUrl, baseWebsiteUrl);
  }

  public init(baseRestUrl?: string, baseUrl?: string) {
    const websiteUrl = baseUrl ?? `//${window.location.host}`;

    // For localhost we want to be fancy
    const isLocalHost = websiteUrl.includes('localhost');
    const computedApiLocation = !isLocalHost ? `//api.${websiteUrl.substring(2)}` : websiteUrl;

    // Usually there is a baseRestUrl, but if it isn't there, we use something based on the browser's location
    const restUrl = baseRestUrl ? baseRestUrl : computedApiLocation;

    this._apiLocation = restUrl;
    this._websiteLocation = websiteUrl;
  }

  public get ApiLocation(): string {
    return this._apiLocation;
  }

  public get WebsiteLocation(): string {
    return this._websiteLocation;
  }
}

export const baseUrlService = new BaseUrlService();
